export class CreditCardSetActiveRequest {

    IsActive: boolean;
    CreditCardID: number;

}
